import { EpochEnum } from '@acme/api/admin';

export type ApplicationListTabConfig = {
  key: string;
  title: string;
  epochId: number | null;
};

export const clientApplicationListTabs: ApplicationListTabConfig[] = [
  { key: 'all', title: 'Все', epochId: null as number | null },
  { key: 'new', title: 'Черновики', epochId: EpochEnum.New },
  { key: 'review', title: 'На проверке', epochId: EpochEnum.Review },
  {
    key: 'changes',
    title: 'Требуются изменения',
    epochId: EpochEnum.ChangesRequired,
  },
  { key: 'confirmed', title: 'Подтверждена', epochId: EpochEnum.Confirmed },
  { key: 'inProgress', title: 'Исполняется', epochId: EpochEnum.InProgress },
  { key: 'completed', title: 'Завершена', epochId: EpochEnum.Completed },
  { key: 'blocked', title: 'Заблокировано', epochId: EpochEnum.Blocked },
];
